import {
  HASH_NOT_VALID,
  PASSWORD_CHANGED,
  ResetPasswordActions,
  ResetPasswordReducerState,
  VALIDATE_PASSWORD_COMPLETE,
  VALIDATE_PASSWORD_ERROR,
  VALIDATE_PASSWORD_PENDING,
} from 'services/AuthService/PasswordResetValidate/types';

const INITIAL_STATE = {
  passwordValidateIsCompleted: false,
  passwordValidateIsPending: false,
  passwordValidateIsError: null,
  hashNotValid: false,
  passwordChanged: false,
};

const passwordValidateReducer = (previousState: ResetPasswordReducerState | undefined, action: ResetPasswordActions) => {
  const state = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case VALIDATE_PASSWORD_COMPLETE:
      return {
        ...state,
        passwordValidateIsCompleted: true,
        passwordValidateIsPending: false,
        passwordValidateIsError: null,
      };
    case VALIDATE_PASSWORD_PENDING:
      return {
        ...state,
        passwordValidateIsCompleted: false,
        passwordValidateIsPending: true,
        passwordValidateIsError: null,
      };
    case VALIDATE_PASSWORD_ERROR:
      return {
        ...state,
        passwordValidateIsCompleted: true,
        passwordValidateIsPending: false,

        passwordValidateIsError: action.error,
      };
    case HASH_NOT_VALID:
      return {
        ...state,
        hashNotValid: true,
      };
    case PASSWORD_CHANGED:
      return {
        ...state,
        passwordChanged: true,
      };

    default:
      return state;
  }
};

export default passwordValidateReducer;
